module.exports = __webpack_public_path__ + "files/7248310441427f1768219cd15fdd9283.png";